import React from 'react';

import { TextInput } from '@strapi/design-system/TextInput';
import Search from '@strapi/icons/Search';
import Cross from '@strapi/icons/Cross';

import styles from './SearchInput.module.css';

const SearchInput = ({
  value,
  onChange,
  onEnter,
  placeholder,
  onReset = () => {},
  label = '',
  className = '',
  showResetBtn = true
}) => {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') onEnter();
  };

  const handleReset = (e) => {
    e.stopPropagation();
    onChange('');
    onReset();
  };

  return (
    <TextInput
      className={className}
      {...(label
        ? {
            label,
          }
        : {})}
      aria-label=" "
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={handleKeyPress}
      startAction={
        <Search
          aria-hidden={true}
          className={`${styles['search-icon']} ${
            value ? styles['search-icon-active'] : ''
          }`}
        />
      }
      {...(value && showResetBtn
        ? {
            endAction: (
              <Cross
                aria-hidden={true}
                onClick={handleReset}
                className={styles['reset-icon']}
              />
            ),
          }
        : {})}
    />
  );
};

export default SearchInput;
